import React from "react"
import { Link } from "gatsby"
import Edit from "../../../../images/edit.svg"
import Loader from "../../../Loader"
import BusinessTitleCard from "../../BusinessCardTitle"
import TinIcon from "../../../../images/business/new-tin.svg"

const Summary = (props) => {
  let {
    rc_number,
    company_name,
    phone,
    email,
    business_address,
    state,
    city,
    certificate_of_registration_name,
  } = props.data

  return (
    <div className="container summary">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <BusinessTitleCard
            title="New TIN"
            subtitle="Apply for a new Tax identification number (TIN)."
            icon={TinIcon}
          />

          <div className="business-suport-card my-lg-5 waitlist__form p-lg-5 p-4">
            <div className="container">
              <div className="row px-lg-5">
                <div className="business-title-step_wrapper pt-5 pb-2 border-bottom">
                  <h4 className="current-step">Application summary</h4>
                  <div className="tag">
                    <span>4 of 4</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Value Added Service</p>
                <p className="summary-description">New TIN Application</p>
              </div>
              <div className="form-group col-md-5 my-3">
                <button
                  className="btn sparkle--button__green_outline px-5 btn-block"
                  onClick={() => props.setShowSummary(false)}
                >
                  <img src={Edit} alt="Edit" className="mr-2 mb-1" />
                  Edit
                </button>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3 offset-lg-">
                <p className="mb-1 summary-title">Business Name</p>
                <p className="summary-description">{company_name}</p>
              </div>

              <div className="form-group col-md-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">BN/RC Number</p>
                <p className="summary-description">{rc_number}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Valid Email Address</p>
                <p className="summary-description">{email}</p>
              </div>

              <div className="form-group col-md-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Phone Number </p>
                <p className="summary-description">{phone}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Business Address</p>
                <p className="summary-description">{business_address}</p>
              </div>

              <div className="form-group col-md-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Place of business</p>
                <p className="summary-description">
                  {state}, {city}
                </p>
              </div>
            </div>

            <div className="form-row">
              <div className="col-lg-12 my-3">
                <p className="mb-1 summary-title">Additional Documents</p>
                <p className="summary-description text-break">
                  {certificate_of_registration_name}
                </p>
              </div>
            </div>

            <div className="form-row  justify-between align-center my-5">
              <div className="form-group col-md-5 my-2">
                <Link
                  to="/business-support/get-started"
                  className="btn sparkle--button__green_outline px-5 btn-block w-100 h-auto"
                >
                  Cancel
                </Link>
              </div>

              <div className="form-group col-md-5 my-2">
                <button
                  className="btn sparkle--button__green px-4 btn-block w-100 h-auto"
                  onClick={props.payFee}
                  disabled={props.loadingStatus}
                >
                  {!props.loadingStatus ? (
                    `Make Payment of ₦ ${props.amount}.00`
                  ) : (
                    <>
                      <Loader width="30" color="#fff" />
                    </>
                  )}
                </button>
              </div>
            </div>

            <p className="sparkle-bright-orange text-center">
              {props.loadingStatus && "Application is in progress..."}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Summary
